import { Assert } from '@team/assert';
import { toEntries } from './to-entries.js';
import { fromEntries } from './from-entries.js';

export const filterUndefined = <K extends string, V>(input: Record<K, V>) =>
  fromEntries(
    toEntries(input).filter(([, value]) => Assert.isDefined(value))
  ) as Record<K, NotUndefined<V>>;
